import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import React, { useMemo, useState } from 'react';

import { SelectionOption } from './types';

export const MultivalueInput = ({
  options,
  onChange,
  initialSelection,
  multiple = true,
}: Readonly<{
  options: SelectionOption[];
  onChange?: (ids: string[]) => void;
  initialSelection?: string;
  multiple?: boolean;
}>) => {
  const initialIds = useMemo(
    () =>
      initialSelection
        ? initialSelection
            .split(',')
            .map(s => s.trim())
            .filter(Boolean)
        : [],
    [initialSelection],
  );

  const initialSelectedOptions = useMemo(() => {
    if (multiple) return options.filter(opt => initialIds.includes(opt.id));
    return options.filter(opt => initialIds.includes(opt.id)).at(0);
  }, [multiple, options, initialIds]);

  const [selected, setSelected] = useState(initialSelectedOptions);

  const getOptionLabel = (option: SelectionOption) => option?.title ?? '';

  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel}
      multiple={multiple}
      value={selected}
      renderInput={params => <TextField {...params} label="Select" />}
      onChange={(_event, value) => {
        setSelected(value!);
        if (onChange) {
          if (value === null) {
            onChange([]);
          } else {
            const changedValue = multiple
              ? (value as SelectionOption[]).map(v => v.id)
              : [(value as SelectionOption).id];
            onChange(changedValue);
          }
        }
      }}
    />
  );
};
